module.exports = "{{$ctrl.policyType}}";